// import { colors } from '../assets/theme'
const fin = (window as any).fin;
export const isOpenfin = typeof fin !== 'undefined';

export class OpenfinAdapter {
  public windows: any;

  public state = {};

  constructor() {
    this.windows = new Map();
    if (typeof fin !== 'undefined') {
      this.loadOpenfin();
      document.body.style.border = `solid 1px #646464`
    }
  }

  public async openWindow(config: any, onClose?: () => void) {
    const { name, url } = config;
    const win = await new fin.desktop.Window({
      alwaysOnTop: true,
      autoShow: true,
      frame: false,
      name,
      url,
      waitForPageLoad: false,
      ...config
    });

    this.windows.set(name, win);
    if (onClose) {
      win.addEventListener('closed', () => {
        onClose();
        this.windows.delete(name);
      });
    }

    return win;
  }

  public getWindow(name: string) {
    return this.windows.get(name);
  }

  public async loadOpenfin() {
    this.state = {
      ...this.state,
      app: await fin.Application.getCurrent(),
      win: await fin.Window.getCurrent()
    };
  }
}

export const Openfin = new OpenfinAdapter();

(window as any).openfin = Openfin;
